import { z } from 'zod/v4';

export const applicationSettingSchema = z.object({
  settingName: z.string(),
  settingValue: z.string(),
  modifiedOn: z.string(),
});

export type ApplicationSetting = z.infer<typeof applicationSettingSchema>;
